"use client";
import { useLogoutWithCleanup } from "@/components/hooks/use-logout-with-cleanup";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export function LogoutAndRefresh() {
  const router = useRouter();
  const { logout } = useLogoutWithCleanup();
  useEffect(() => {
    const run = async () => {
      await logout();
      router.refresh();
    };
    run();
  }, [router, logout]);
  return <div />;
}
